import {
  GET_ADDRESSES,
  SAVE_ADDRESS,
  DELETE_ADDRESS,
  SET_DEFAULT,
  EDIT_ADDRESS,
} from "./actionTypes";
import { normalizeAddresses } from "../../helpers/normalizeAddresses";

const initialState = {
  addresses: [],
  editAddress: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ADDRESSES:
    case SAVE_ADDRESS:
    case DELETE_ADDRESS:
    case SET_DEFAULT:
      return { ...state, addresses: normalizeAddresses(action.payload) };
    case EDIT_ADDRESS:
      return { ...state, editAddress: action.payload };
    default:
      return state;
  }
}
